define('watabs', ['jquery'], function ($) {

	return {
		tabActiveClassName: 'active',
		detailsTabNavigation: $('.product__tabs--navigation'),
		detailsHiddenTabs: $('.product__tab--content.hide'),
		firstTabContent: $('.product__tab--content.show').eq(0),
		resizeTabContent: $('.product__tab--content').eq(0),
		tabHeadlineMobile: $('.product__tab--headline'),

		detailsTabs: function detailsTabs() {
			var _this = this;

			var tabLinks = this.detailsTabNavigation.find('a');
			var activeContentId = this.firstTabContent.attr('id');

			var setActiveClass = function setActiveClass() {
				if (window.innerWidth <= 480) {
					setActiveClassMobile();
				} else {
					setActiveClassDesktop();
				}
			};

			var setActiveClassMobile = function setActiveClassMobile() {
				return _this.detailsTabNavigation.find('a').find('[href="#' + activeContentId + '"]').addClass(_this.tabActiveClassName);
			};

			var setActiveClassDesktop = function setActiveClassDesktop() {
				return _this.detailsTabNavigation.find('a').removeClass(_this.tabActiveClassName).end().find('[href="#' + activeContentId + '"]').addClass(_this.tabActiveClassName);
			};

			var removeActiveClass = function removeActiveClass() {
				return _this.detailsTabNavigation.find('a').find('[href="#' + activeContentId + '"]').removeClass(_this.tabActiveClassName);
			};

			var setActiveContent = function setActiveContent() {
				if (window.innerWidth <= 480) {
					setActiveContentMobile();
				} else {
					setActiveContentDesktop();
				}
			};

			var setActiveContentMobile = function setActiveContentMobile() {
				return _this.detailsHiddenTabs.parent().find('#' + activeContentId).fadeIn();
			};

			var setActiveContentDesktop = function setActiveContentDesktop() {
				return _this.detailsHiddenTabs.hide().parent().find('#' + activeContentId).fadeIn();
			};

			setActiveClass();

			var closeActiveContent = function closeActiveContent() {
				return _this.detailsHiddenTabs.parent().find('#' + activeContentId).fadeOut();
			};

			var startTabFunctionality = function startTabFunctionality(e) {
				e.preventDefault();
				setActiveClass();
				setActiveContent();
			};

			var closeTabFunctionality = function closeTabFunctionality(e) {
				e.preventDefault();
				removeActiveClass();
				closeActiveContent();
			};

			tabLinks.on('click', function (e) {
				activeContentId = $(e.currentTarget).attr('href').replace('#', '');
				startTabFunctionality(e);
			});

			this.tabHeadlineMobile.on('click', function (e) {
				var self = $(e.currentTarget);
				activeContentId = self.data('href').replace('#', '');

				if (self.hasClass(_this.tabActiveClassName)) {
					self.removeClass(_this.tabActiveClassName);
					closeTabFunctionality(e);
				} else {
					self.addClass(_this.tabActiveClassName);
					startTabFunctionality(e);
				}
			});
		},
		openFirstTab: function openFirstTab() {
			this.tabHeadlineMobile.eq(0).trigger('click');
		},
		resizeTabs: function resizeTabs() {
			var self = this;

			window.addEventListener("resize", function () {
				if (window.innerWidth > 480) {
					if ($('.product__tab--headline.active').length) {
						var activeContentDesktop = $('.product__tab--headline.active').data('href');
						self.tabHeadlineMobile.removeClass('active');
						$('a[href="' + activeContentDesktop + '"]').click();
					}
				} else {
					if ($('.product__tabs--navigation a.active').length) {
						var activeContentMobile = $('.product__tabs--navigation a.active').attr('href');
						$('.product__tabs--navigation a').removeClass('active');
						var activeTab = $('[data-href="' + activeContentMobile + '"]');
						if (!activeTab.hasClass('active')) {
							activeTab.addClass('active');
						}
					}
				}
			});
		},
		init: function init() {
			this.detailsTabs();
			this.openFirstTab();
			this.resizeTabs();
		}
	};
});

